// ═══ 차량 상세 저장 diff — 패널을 열 때 받은 /full 스냅샷(getDefaultEditForm) 대비 바뀐 키만 ═══
// 서버 PUT /cars/:id 는 body 에 키가 없으면 기존값 유지 — 안 바꾼 칸을 되보내 남의 수정을 덮지 않게 한다.
// 동등 판정은 문자열화 기준(0 vs '0', null vs '') · 한쪽이 숫자면 값 비교(DECIMAL '1200.00' vs 1200).
// ids — { ownerId: { orig: {front, back}, cur: {front, back}, value } } : 입력칸이 원본에서 바뀐 경우만 value 를 싣는다.
//   원본이 복호 불가 표시('******-*******')면 입력칸에 숫자가 하나도 없을 때 싣지 않는다 (빈칸 = 삭제로 실값 유실 방지).
//   일반 마스킹('730113-*******') 원본을 비우면 value('') 를 싣는다 — 기존 동작(삭제) 유지.
function same(a, b) {
  var x = a == null ? '' : String(a), y = b == null ? '' : String(b);
  if (x === y) return true;
  if (typeof a !== 'number' && typeof b !== 'number') return false;
  return x.trim() !== '' && y.trim() !== '' && Number(x) === Number(y);
}

export function carEditDiff(base, form, ids) {
  var out = {};
  Object.keys(base || {}).forEach(function (k) { if (!same(base[k], form[k])) out[k] = form[k]; });
  Object.keys(ids || {}).forEach(function (k) {
    var o = ids[k].orig || {}, c = ids[k].cur || {};
    if (String(o.front || '') === String(c.front || '') && String(o.back || '') === String(c.back || '')) return;
    if (String(o.front || '').indexOf('*') >= 0 && !/[0-9]/.test(String(c.front || '') + String(c.back || ''))) return;
    out[k] = ids[k].value;
  });
  return out;
}
